<template>
    <div class="py-0.5 xs:py-1 text-center font-normal tracking-relaxed leading-snug text-gray-800 hover:text-blue-600 cursor-pointer select-none transition-colors"
        :class="spanish || italian ? 'text-xs md:text-xs lg:text-sm' : 'text-xs md:text-sm lg:text-base'"
        @click="$emit('click')"
    >
        <slot />
    </div>
</template>

<script>
export default {
    data() {
        return {
            spanish: window.locale == 'sp',
            italian: window.locale == 'it',
        }
    },
}
</script>
